import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { TokenInterceptor } from './services/token.interceptor';
import { GraphApi } from './services/graph-api.service';
import { fromAdUser } from './reducers';
import { StoreModule } from '@ngrx/store';
import { AdUserEffects, GraphApiEffects } from './effects';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { GraphApiLoggingTransformer } from './transformers';
import * as i0 from "@angular/core";
export class GraphApiModule {
    static { this.ɵfac = function GraphApiModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GraphApiModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GraphApiModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: HTTP_INTERCEPTORS,
                useClass: TokenInterceptor,
                multi: true
            },
            GraphApi,
            provideHttpClient(withInterceptorsFromDi())
        ], imports: [CommonModule,
            AuthModule,
            EffectsModule.forFeature([AdUserEffects, GraphApiEffects]),
            StoreModule.forFeature('adUser', fromAdUser.adUserReducer),
            LoggingModule.withExtraParams([GraphApiLoggingTransformer])] }); }
}
//# sourceMappingURL=graph-api.module.js.map